/**
 * @Author:      skyeGao
 * @Email:       yyjzp1314@126.com
 * @DateTime:    2019-03-24 22:31:49
 * @Description: 公共 request 
 */

import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
// import { getToken, sudoLogin } from '@/utils/auth'
import { WEBSITE_BASEURL } from '../utils/global'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_API, // api 的 base_url
  baseURL: WEBSITE_BASEURL, // api 的 base_url  后期需要更改config配置  区分dev和pro  实际上有了这个  则不需要vue.config.js里的proxy代理配置
  timeout: 5000 // request timeout
})

// request interceptor
// service.interceptors.request.use(
//   config => {
//     // Do something before request is sent
//     // if (store.getters.token) {
//     if (getToken()) {
//       // 让每个请求携带token-- ['y-Token']为自定义key 请根据实际情况自行修改
//       config.headers['y-token'] = getToken()
//     }
//     return config
//   },
//   error => {
//     // Do something with request error
//     console.log(error) // for debug
//     Promise.reject(error)
//   }
// )

// response interceptor
service.interceptors.response.use(
  // response => response,
  response => {
    return response.data.data
  },
  error => {
    console.log('err' + error) // for debug
    /*Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000
    })*/
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/Epub/utils/request.js